/* eslint-disable no-unused-vars */
export enum CodesPermissions {
	ACOMPANAMIENTO_EN_SALUD_CONTINUO = 'ASC',
	ACTIVIDAD_FISICA = 'ACF',
	ACTUALIZAR_DATOS = 'ACDP',
	ACCESO_DIRECTO = 'ACD',
	BOTON_ACCESOS_DIRECTOS = 'ADD',
	AGENDAMIENTO_DE_CITAS = 'ACI',
	AGENDAMIENTO_DE_CLASES = 'ACS',
	AGREGAR_A_TU_SER_QUERIDO = 'ASQ',
	AGREGAR_CONDICION = 'ADC',
	AJUSTES = 'AJU',
	ALIADOS = 'ALLY',
	ALIADOS_EMERGENTE = 'AEM',
	ALIMENTACION = 'ALM',
	APRENDE_A_CUIDARLOS = 'AAC',
	ASESORIA_MEDICA_RAPIDA = 'AMR',
	ASESORIA_RAPIDA_COVID_19 = 'ARC',
	ASISTENTE_DE_SALUD = 'ADS',
	ATENCION_AL_CLIENTE = 'ALC',
	AYUDA = 'AYU',
	BUSCADOR_DE_HERRAMIENTAS = 'BDH',
	BUSCADOR_DE_PROGRAMAS = 'BDP',
	CALCULO_DE_IMC = 'IMC',
	CALIFICA_TU_EXPERIENCIA = 'CAE',
	CENTROS_DE_CUIDADO = 'CDC',
	CERRAR_SESION = 'LOGU',
	CHAT_EN_LINEA = 'CHL',
	COMPONENTE_BENEFICIOS_EMPRESA = 'CBE',
	CONOCE_TU_ESTADO_DE_SALUD = 'CES',
	CITA_DE_CONTROL = 'CTL',
	DEFAULT = 'DF',
	EN_VIVOS = 'EVV',
	ENTRENA_TUS_HABITOS = 'ENTH',
	HABLA_CON_TU_MENTOR = 'HCM',
	HABLA_CON_TU_MENTOR_THM = 'THM', // Note: Duplicate entry "THM"
	INFORMACION_GENERAL = 'ING',
	INGRESO_A_CENTROS_DE_CUIDADO = 'ICC',
	INGRESO_A_CLASES = 'ICS',
	LECTURA_DE_EXAMENES = 'LDE',
	MI_PERFIL = 'MPE',
	MI_RUTINA = 'MRT',
	MIS_PROGRAMAS = 'MPS',
	MONITOREA_TU_CONDICION = 'MTC',
	ORDENES_DE_EXAMENES = 'ODE',
	ORIENTACION_PSICOLOGICA = 'OPS',
	ORIENTACION_PSICOLOGICA_TCM = 'TCM', // Note: Duplicate entry "TCM"
	PAC = 'PAC',
	PAC_SMARTFIT = 'RPAC',
	PARQ_CENTROS_DE_CUIDADO = 'PQCC',
	PLATAFORMAS_SMARTFIT = 'PAC-PSF',
	PREGUNTAS_EMERGENTES = 'PEM',
	PROGRAMAS = 'PRO',
	PRUEBA_DE_DIABETES = 'PDD',
	PRUEBA_DE_EMBARAZO = 'PDE',
	QR_DE_CENTRO_DE_CUIDADO = 'QRC',
	RECORDATORIO_MEDICAMENTOS = 'RMS',
	RECUERDA_TOMAR_TUS_MEDICAMENTOS = 'RTM',
	RED_DE_CUIDADO = 'REDC',
	RENOVACION_DE_FORMULAS_MEDICAS = 'RFM',
	RESULTADOS_ENCUESTA_DE_HABITOS = 'REH',
	SALUD_MENTAL = 'SML',
	TEXT_SOLO_USUARIOS_COMFAMA = 'SUC',
	SINTOMAS_Y_CONDICIONES = 'SYC',
	SOLICITUD_DE_CITA_MEDICA = 'SCN',
	SUENO_REPARADOR = 'SER',
	TIENDA_DEL_CUIDADO = 'TDC',
	TIENES_GLUCOMETRO = 'TGL',
	TIENES_TENSIOMETRO = 'TTS',
	TOOLS = 'TOOLS',
	TU_CONDICION = 'TCN',
	TUS_CONTROLES = 'TCS',
	ULTIMA_CITA_DE_CONTROL = 'UCC',
	ULTIMOS_EXAMENES = 'UEX'
}

export const PermissionsTools = {
	'asesoria-medica-covid': CodesPermissions.ASESORIA_RAPIDA_COVID_19,
	'cita-control': CodesPermissions.CITA_DE_CONTROL,
	'exam-read': CodesPermissions.LECTURA_DE_EXAMENES,
	'orientacion-psicologica-a-familiar-cuidador': CodesPermissions.ORIENTACION_PSICOLOGICA,
	'orientador-virtual-de-salud': CodesPermissions.HABLA_CON_TU_MENTOR, // Clave para Habla con tu mentor
	'orientador-virtual-en-habitos': CodesPermissions.HABLA_CON_TU_MENTOR_THM,
	'prueba-de-diabetes': CodesPermissions.PRUEBA_DE_DIABETES,
	'prueba-de-embarazo': CodesPermissions.PRUEBA_DE_EMBARAZO,
	exam: CodesPermissions.SOLICITUD_DE_CITA_MEDICA,
	fast: CodesPermissions.ASESORIA_MEDICA_RAPIDA,
	orders: CodesPermissions.ORDENES_DE_EXAMENES,
	psychology: CodesPermissions.ORIENTACION_PSICOLOGICA_TCM,
	renovation: CodesPermissions.RENOVACION_DE_FORMULAS_MEDICAS
}
